import womanOnBath from '../../../assets/images/womanOnBath.png';

function whyUs() {
  return ( 
    <div className='whyUs'>
      <div className='whyUs__wrapper'>
        <div className='whyUs__left'>
          <div className='whyUs__header'>
            <div className='whyUs__header-hashtags'>
              <p className='whyUs__header-tags'># КРАСОТА</p>
              <p className='whyUs__header-tags'># УХОД</p>
              <p className='whyUs__header-tags'># ЗДОРОВЬЕ</p>
            </div>
            <p className='whyUs__header-text'>ПОЧЕМУ ВЫБИРАЮТ НАС?</p>
          </div>
          <div className='whyUs__info'>
            <p className='whyUs__info-text'>
              <span className='whyUs__info-text-strong'>Индивидуальный подход:</span> учитываем особенности каждого клиента.
            </p>
            <p className='whyUs__info-text'>
              <span className='whyUs__info-text-strong'>Комплексное воздействие:</span> сочетаем различные методики для максимального эффекта.
            </p>
            <p className='whyUs__info-text'>
              <span className='whyUs__info-text-strong'>Естественное преображение:</span> без агрессивного вмешательства в организм.
            </p>
            <p className='whyUs__info-text'>
              <span className='whyUs__info-text-strong'>Расслабление и оздоровление:</span> процедуры не только корректируют фигуру, но и улучшают общее самочувствие.
            </p>
          </div>
        </div>
        <div className='whyUs__right'>
          <img src={womanOnBath} alt="Девушка сидит у ванны" />
        </div>
      </div>
    </div>
   );
}

export default whyUs;